import { AnalyticsService } from 'src/app/services/analytics.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location, DatePipe } from '@angular/common';
import { AppConstant } from 'src/app/utilities/app.constants';
import { CustomDialogService } from 'src/app/shared/custom-dialog.service';
import { ActivatedRoute } from '@angular/router';
import { AppSpinnerService } from 'src/app/services/app-spinner.service';
import html2canvas from 'html2canvas'; 
import * as jspdf from 'jspdf';  
import { SettingsService } from './../../../../services/settings.service';


@Component({
  selector: 'app-safety-rating-feedback',
  templateUrl: './safety-rating-feedback.component.html',
  styleUrls: ['./safety-rating-feedback.component.scss']
})
export class SafetyRatingFeedbackComponent implements OnInit {

  @ViewChild('safetyratingfeedback', { static: false }) safetyratingfeedback: ElementRef;
  safetyRating: any;
  safetyRatingDetails: any;
  crewMemberRank = '';
  submitterCrewId = '';
  submitterRank = '';
  submitterName = '';
  safetyRatingDetailView = false;
  submitterProfileImage = '';
  crewUserName: '';
  ratingDataArray = ["Unsatisfactory","Needs Imporvement","Meets Expectations","Exceeds Expectations","Exceptional"];
  constructor(
    private location: Location,
    private readonly analyticsService: AnalyticsService,
    private readonly customDialogService: CustomDialogService,
    private readonly activatedRoute: ActivatedRoute,
    public appSpinner: AppSpinnerService,
    public datepipe: DatePipe,
    private settingsService: SettingsService
    ) { }

  ngOnInit() {
    this.getSubmitterDetailSetting();
    // const ratingMasterId =  this.activatedRoute.snapshot.paramMap.get('ratingMasterId');
    let ratingMasterId = ''; 
    this.activatedRoute.queryParams.subscribe(params => {
      ratingMasterId = params["Id"];
      this.crewMemberRank = params["rank"];
  });
    console.log('ratingMasterId',ratingMasterId);
    this.fetchSafetyRatingDetails(ratingMasterId);
  }

  fetchSafetyRatingDetails(ratingId: string) {
    this.appSpinner.show();
    this.analyticsService.getRatingDetails(ratingId).subscribe((ratingDetails: []) => {
      this.safetyRatingDetails = ratingDetails;
      this.safetyRating = this.safetyRatingDetails[0];
      this.safetyRating.userId.rank = this.crewMemberRank;
      this.crewUserName = this.safetyRating.userId.firstName;
  
      //setting the submitter Details
      this.submitterCrewId = this.safetyRatingDetails[0].ratingMasterId.submitterDetails.crewId;
      this.submitterRank = this.safetyRatingDetails[0].ratingMasterId.submitterDetails.rank;
      this.submitterName = this.safetyRatingDetails[0].ratingMasterId.submitterDetails.name;
      this.submitterProfileImage = this.safetyRatingDetails[0].ratingMasterId.submitterDetails.imageBase64;
      this.appSpinner.hide();
    });
    
  }

  // replaceLineBreak(ratingLabel: string) {
  //   return ratingLabel.split('.')[1].replace('<br>', ' ');
  // }

  getSubmitterDetailSetting(){
    this.settingsService.getSubmitterDetailViewStatus().subscribe((data : any) => {
      if(data){
        this.safetyRatingDetailView = data.showSubmitterDetail;
      }
    })
  }

  replaceLineBreak(rating: number) {
    let data = this.ratingDataArray[rating-1];
    return data;
  }

  goBack() {    
    this.location.back();
    this.analyticsService.isChartView = false;
  }

  onAddPDF() {
    let avgRatingList = this.safetyRating.ratingMasterId.finalRating == 0 ? '-' : parseFloat(this.safetyRating.ratingMasterId.finalRating).toFixed(2);
    let crewObj = {
      crewId:' '+ this.safetyRating.userId.crewId,
      crewName:' '+this.safetyRating.userId.firstName+ ' '+this.safetyRating.userId.anotherName,
      Rank:' '+this.safetyRating.userId.rank,
      // Department: 'Department:'+ ' '+this.department,
      // Category: 'Category:'+ ' '+this.category,
      avgRating:' '+avgRatingList,
      vesselName:' ' +this.safetyRating.vesselName
    }
    const content = this.safetyratingfeedback.nativeElement;
    html2canvas(content,{scale: 2}).then(canvas => {  
        // Few necessary setting options  
        var imgWidth = 200;  
        var pageHeight = 400;    
        var imgHeight = canvas.height * imgWidth / canvas.width;  
        var heightLeft = imgHeight;  
    
        const contentDataURL = canvas.toDataURL('image/png')  
        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF  
        var position = 80;  
        pdf.addImage(contentDataURL, 'PNG', 5, position, imgWidth, 110);
        pdf.setFontSize(13);
      this.addHeaderAndFooter(pdf,crewObj);
      this.addRatingDescription(pdf);
        pdf.save('Crew-Rating-Feedback.pdf'); // Generated PDF   
      });
    }
    
  addHeaderAndFooter(pdfObject,crewobj) {
    const date = this.datepipe.transform(this.safetyRating.createdAt, 'dd/MM/yyyy');
    var number_of_pages = pdfObject.internal.getNumberOfPages();
    var pdf_pages = pdfObject.internal.pages;
    var report_name = 'Crew Rating Feedback'+ ' on ' +date;
    const todayDate = new Date();
    const currentDate = this.datepipe.transform(todayDate, 'dd/MM/yyyy');
    for (var i = 1; i < pdf_pages.length; i++) {
      // We are telling our pdfObject that we are now working on this page
      pdfObject.setPage(i);
      pdfObject.text(currentDate, 175, 270);
      pdfObject.text(crewobj.crewId, 24, 40);
			pdfObject.text(crewobj.crewName, 21, 50);
      pdfObject.text(crewobj.Rank, 20, 60);
      pdfObject.text(crewobj.vesselName, 99, 60);
      pdfObject.text(crewobj.avgRating, 196, 60);
      pdfObject.setFontType('bold');
      pdfObject.text('Downloaded on Date:', 127, 270);
      pdfObject.text('Analytics',175, 15);
      pdfObject.text(report_name,65,30);
      pdfObject.text('Crew ID :',5, 40);
			pdfObject.text('Name :',5, 50);
			pdfObject.text('Rank :',5, 60);
			pdfObject.text('Vessel :',80,60);
			pdfObject.text('Safety Rating :',162,60);
      pdfObject.text(AppConstant.HEADER_TEXT,22, 15);
      pdfObject.addImage(AppConstant.IMG_HEADER, 'png', 5, 7, 15, 15);
      pdfObject.addImage(AppConstant.IMG_FOOTER, 'png', 5, 280, 60, 15);
      pdfObject.text('Page ' + i + '/' + number_of_pages, 
      pdfObject.internal.pageSize.getWidth() - 30, pdfObject.internal.pageSize.getHeight() - 10);
    }
  }

  addRatingDescription(pdfObject) {
    var number_of_pages = pdfObject.internal.getNumberOfPages();
    var pdf_pages = pdfObject.internal.pages;
    for (var i = 1; i < pdf_pages.length; i++) {
      if (i == number_of_pages) {
        pdfObject.setFontSize(10)
        pdfObject.setFontType('unbold');
        pdfObject.text(' Unsatisfied', 10, 195);
        pdfObject.text(' Needs Improvements', 10, 200);
        pdfObject.text(' Meets Expectations', 10, 205);
        pdfObject.text(' Exceeds Expectations', 10, 210);
        pdfObject.text(' Exceptional', 10, 215);
        pdfObject.setFontType('bold');
        pdfObject.text('Rating Scale:-', 5, 190);
        pdfObject.text('1 :', 5, 195);
        pdfObject.text('2 :', 5, 200);
        pdfObject.text('3 :', 5, 205);
        pdfObject.text('4 :', 5, 210);
        pdfObject.text('5 :', 5, 215);
      }
    }
  }

  submitterDetailsDialogue(){
    const msg = `Submitted By:`;
    this.customDialogService.setSubmitterImage(this.submitterProfileImage);
    this.customDialogService.showSubmitterDetailsDialogue(msg,this.submitterCrewId,this.submitterName,this.submitterRank,'dismiss');
  }

}
